/*
 * @Description:
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2022-07-09 19:57:22
 * @LastEditors: YGQ
 * @LastEditTime: 2023-12-25 19:07:32
 */
import axios from "axios";
import { getEnvironment } from "@/utils";
import { URL, SSO_HOST } from "@/const/";
import { ElMessage, ElLoading } from 'element-plus'
import VueCookies from 'vue-cookies'
axios.defaults.withCredentials = true;

const ENV = getEnvironment();
const BASE_URL = URL[ENV];
const MOCK_URL = URL.mock;
const SSO_URL = SSO_HOST[ENV] // 用户中心认证地址


// 请求拦截器
axios.interceptors.request.use(config => {
  let browserId = localStorage.getItem('browserId') // 浏览器指纹，在项目中用于校验用户身份和埋点
  config.headers['Browser-Id'] = browserId  // 在每个请求中添加浏览器指纹
  return config;
});
// 响应拦截器 
axios.interceptors.response.use(res => {
  const { data } = res;
  // 用户未登录 则跳回用户中心页面
  if (data.code === 2001) {
    VueCookies.remove("TOKEN"); // 清除本地 token
    let oneid = SSO_URL + "/sso?app_name=pms-manage&redirect_url=";
    oneid += encodeURIComponent(`http://${window.location.host}/pms-manage/#/oneid`); // 定义重定向地址
    setTimeout(() => {
      window.location.href = oneid
    }, 800);
  }
  return res;
})

// 加载状态的全局配置
const LoadingOptions = { fullscreen: true }

/**
 * get 请求
 * @param {String} api 请求的api接口
 * @param {Object} [params] 请求参数[可选]
 * @return {Function} 请求成功后继续处理数据
 */
async function get (api, params = {}) {
  let noLoading = params?.noLoading ?? false
  params = requestFit(params); // 请求前的数据适配
  let url = !params.mock ? BASE_URL + api : MOCK_URL + api;
  const loadingInstance = noLoading ? {} : ElLoading.service(LoadingOptions)
  try {
    const response = await axios.get(url, { params });
    !noLoading && loadingInstance.close() // 关闭加载态
    return onSuccess(api, params, response, this); // 请求成功回调
  } catch (error) {
    !noLoading && loadingInstance.close() // 关闭加载态
    ElMessage("请求超时，请稍后刷新重试", "warning");
  }
}

/**
 * post 请求
 * @param {String} api 请求的api接口
 * @param {Object} params 请求参数
 * @return {Function} 请求成功后继续处理数据
 */
async function post (api, params = {}) {
  params = requestFit(params); // 请求前的数据适配
  const url = !params.mock ? BASE_URL + api : MOCK_URL + api;
  const loadingInstance = ElLoading.service(LoadingOptions)
  delete params.mock;
  try {
    const response = await axios.post(url, params);
    loadingInstance.close() // 关闭加载态
    return onSuccess(api, params, response); // 请求成功回调
  } catch (error) {
    loadingInstance.close() // 关闭加载态
    ElMessage("请求超时，请稍后刷新重试", "warning");
  }
}

/**
 * 请求成功回调
 * @param {String} api 请求的api接口
 * @param {Object} params 请求参数
 * @param {Promise} response 请求返回
 * @return {Array} 返回[res, err]其中报错时才有err参数
 */
function onSuccess (api, params, response) {
  const data = responseFit(response?.data); // 对返回数据适配
  if (process.env.NODE_ENV === "development") {
    console.group(api, params);
    if (params.mock) console.warn("返回 MOCK 数据");
    console.log(data); // 开发环境下控制台打印返回
    console.groupEnd();
  }
  if (data && data.ok) {
    return [data.data, null]; // 正常时将提取出里层data返回
  } else if (data && !data.ok) {
    return [null, data.msg || "", data.data || []]; // 异常时返回信息
  }
}

/**
 * 请求发送前的数据适配
 * @param {Object} data 请求参数
 * @return {Object} 经处理的data
 */
function requestFit (data) {
  return camel2snake(data); // 驼峰转下划线
}

/**
 * 数据返回后的数据适配
 * @param {Object} data 请求参数
 * @return {Object} 经处理的data
 */
function responseFit (data) {
  return snake2camel(data); // 下划线转驼峰
}

// 将 camelCase 转为 snake_case
function camel2snake (data) {
  if (typeof data !== "object" || !data) {
    return data;
  }
  if (Array.isArray(data)) {
    return data.map((item) => camel2snake(item));
  }
  const newData = {};
  for (const key in data) {
    const newKey = key.replace(/([A-Z])/g, (p, m) => `_${m.toLowerCase()}`);
    newData[newKey] = camel2snake(data[key]);
    if (
      data[key] &&
      Number.isFinite(data[key]) &&
      parseInt(data[key], 10) != data[key]
    ) {
      newData[newKey] = Number(data[key].toFixed(2));
    }
  }
  return newData;
}

// 将 snake_case 转为 camelCase
function snake2camel (data) {
  if (typeof data !== "object" || !data) {
    return data;
  }
  if (Array.isArray(data)) {
    return data.map((item) => snake2camel(item));
  }
  const newData = {};
  for (const key in data) {
    const newKey = key.replace(/_([a-z])/g, (p, m) => m.toUpperCase());
    newData[newKey] = snake2camel(data[key]);
  }
  return newData;
}

/**
 * 将请求方法注入全局
 * 需在 main.js 里面 use 本方法
 */
const install = (app, options) => {
  app.config.globalProperties.$host = BASE_URL;
  app.config.globalProperties.$post = post;
  app.config.globalProperties.$get = get;
  app.config.globalProperties.$env = ENV
};

export default {
  install,
};
